import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authenticationReducer from "./reducers/authenticationSlice";
import analyticsReducer from "./reducers/graphSlice";
import indicatorReducer from "./reducers/indicatorSlice";
import dataReducer from "./reducers/dataSlice";
import logger from "redux-logger";
import adminReducer from "./reducers/AdminSlice";
import eventReducer from "./reducers/EventSlice";
import selectedReducer from "./reducers/SelectedSlice";

const combinedReducer = combineReducers({
  authentication: authenticationReducer,
  analyticsGraph: analyticsReducer,
  indicator: indicatorReducer,
  data: dataReducer,
  admin: adminReducer,
  event: eventReducer,
  selected: selectedReducer,
});
const rootReducer = (state, action) => {
  if (action.type === "authentication/logout") {
    // check for action type
    state = undefined;
  }
  return combinedReducer(state, action);
};
export default configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(logger),
});
